import * as React from 'react';
import { ButtonCheckboxList } from '../button_checkbox_list';
import { Row } from '../../markup';
import { ECoworkingAccess } from '../../../../../json_query';

const CoworkingAccessOptions = [
  { title: 'Круглосуточно', value: ECoworkingAccess.AllDay },
  { title: 'В выходные дни', value: ECoworkingAccess.AllWeek },
];

interface ICoworkingAccessProps {
  selected: ECoworkingAccess[];
  onSelect(value: ECoworkingAccess): void;
}

export const CoworkingAccess: React.StatelessComponent<ICoworkingAccessProps> = ({ selected, onSelect }) => (
  <Row title="Доступ">
    <ButtonCheckboxList selected={selected} select={onSelect} deselect={onSelect} list={CoworkingAccessOptions} />
  </Row>
);
